import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'CmgPasswordResetRequestPage',
})
export default class CmgPasswordResetRequestPage extends Vue {
  email = '';
  errorMessage = '';
  isFormValid = true;
  isPasswordResetRequest = true;

  get pepperBadgeUrl(): string {
    return this.$appStore.state.cms.images.icons.pepperBadge.default;
  }
}
